export class WorkflowMigrationRequest {
  clientId: string;
  workflowName: string;
  templateWorkflowId?: string;
  overwriteExistingWorkflow: boolean;
  isVerified: boolean;
  migrationProcessingId?: string;
  customListsToUpdate?: string[];
  rolesToUpdate?: string[];

  constructor(options?: Partial<WorkflowMigrationRequest>) {
    this.clientId = '';
    this.workflowName = '';
    this.overwriteExistingWorkflow = false;
    this.isVerified = false;

    if (options) {
      Object.assign(this, options);
    }
  }
}
